import _isEqual from 'lodash.isequal';

export function isEqual<T = any>(value: T, other: T) {
  return _isEqual(value, other);
}
